// src/components/Footer.jsx
import { CalendarDaysIcon, HandRaisedIcon } from '@heroicons/react/24/outline'
import { useState } from "react";
import { submitNewsletter } from '../api/contactApi';


export default function Footer() {
  const [status, setStatus] = useState({ loading: false, success: false, err: "" });
  const [form, setForm] = useState({ email: ""});

  function onChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  }

  function reset() {
    setForm({ email: "" });
  }

  async function onSubmit(e) {
    e.preventDefault();
    setStatus({ loading: true, success: false, err: "" });

    try {
      await submitNewsletter(form.email);
      setStatus({ loading: false, success: true, err: "" });
      reset();
    } catch (err) {
      setStatus({ loading: false, success: false, err: String(err.message || err) });
    }
  }

  return (
    <footer className="relative isolate overflow-hidden bg-slate-800 py-16 sm:py-24 lg:py-32 mt-auto">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Newsletter + Features */}
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-2">
          {/* Left column */}
          <div className="max-w-xl lg:max-w-lg">
            <h2 className="text-4xl font-semibold tracking-tight text-white">
              Subscribe to our newsletter
            </h2>
            <p className="mt-4 text-lg text-gray-300">
              Stay updated with new articles, tools, and insights in IT, automation, and software development.
            </p>

            {/* Newsletter form */}
            <form
              onSubmit={onSubmit}
              className="mt-6 flex max-w-md gap-x-4"
            >
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                required
                placeholder="Enter your email"
                value={form.email} onChange={onChange}                
                autoComplete="email"
                className="min-w-0 flex-auto rounded-md bg-white/5 px-3.5 py-2 text-base text-white outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6"
              />
              <button
                type="submit"
                className="flex-none rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
              >
                Subscribe
              </button>
            </form>
              {status.success && <span className="text-sm text-green-600">Thanks! I’ll reply soon.</span>}
              {status.err && <span className="text-sm text-red-600">{status.err}</span>}            
          </div>

          {/* Right column (features) */}
          <dl className="grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:pt-2">
            <div className="flex flex-col items-start">
              <div className="rounded-md bg-white/5 p-2 ring-1 ring-white/10">
                <CalendarDaysIcon aria-hidden="true" className="h-6 w-6 text-white" />
              </div>
              <dt className="mt-4 text-base font-semibold text-white">
                Weekly articles
              </dt>
              <dd className="mt-2 text-base text-gray-400">
                Get weekly insights on automation, systems engineering, and modern software development.
              </dd>
            </div>
            <div className="flex flex-col items-start">
              <div className="rounded-md bg-white/5 p-2 ring-1 ring-white/10">
                <HandRaisedIcon aria-hidden="true" className="h-6 w-6 text-white" />
              </div>
              <dt className="mt-4 text-base font-semibold text-white">No spam</dt>
              <dd className="mt-2 text-base text-gray-400">
                We respect your inbox. Only meaningful updates—no marketing fluff.
              </dd>
            </div>
          </dl>
        </div>

        {/* Divider + bottom links */}
        <div className="mt-16 border-t border-white/10 pt-8 flex flex-col sm:flex-row 
        items-center justify-between gap-y-4 text-sm text-gray-400">
          <nav aria-label="Footer" className="flex flex-wrap justify-center gap-x-6 gap-y-3">
            <a href="/" className="hover:text-white">Home</a>
            <a href="/about" className="hover:text-white">About</a>
            <a href="/services" className="hover:text-white">Services</a>
            <a href="/blog" className="hover:text-white">Blog</a>
            <a href="/projects" className="hover:text-white">Projects</a>
            <a href="/lifesafetyai" className="hover:text-white">LifeSafetyAI</a>
            {/* <a href="/resume" className="hover:text-white">Resume</a> */}
            <a href="/contact" className="hover:text-white">Contact</a>
            <a href="/privacy-policy" className="hover:text-white">Privacy Policy</a>
            <a href="/terms" className="hover:text-white">Terms</a>
          </nav>
          <p className="text-center sm:text-right">
            © {new Date().getFullYear()} Angelo Ruiz | <a href="https://angeloruiz.com" className="hover:text-white">angeloruiz.com</a> | All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
